// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportHistoryListActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import { curry, isEmpty } from 'lodash/fp';

/**
 * Handle check all
 * @param {Object} props
 * @param {Object} data
 */
function handleCheckAll(props: any, data: any) {
  const {
    store: { model }
  } = props;

  if (!isEmpty(model.historyFiles)) {
    model.updateCheckAll();
  }
}

/**
 * Handle check each item
 * @param {Object} props
 * @param {Object} data
 */
function handleCheckItem(props: any, data: any) {
  data.updateSelected();
}

/**
 * Handle delete item
 * @param {Object} props
 * @param {Object} data
 */
function handleDeleteItem(props: any, data: any) {
  const {
    store,
    store: {
      model,
      model: { historyFiles, pageIndex }
    }
  } = props;
  const { fileName } = data;
  props
    .confirmFn('Information', {
      description: String.format(props.localization.getText('IMPORT_DELETE_MESSAGE'), fileName),
      type: 'warning',
      showCloseIndicator: false
    })
    .then(() => {
      store.deleteHistories(data).then(success => {
        if (success) {
          // Check if delete all in page, return previous page
          if (historyFiles.length === 1 && pageIndex > 1) {
            model.updatePageIndex(pageIndex - 1);
          }
          props.loadHistories();
        }
        return Promise.resolve(success);
      });
    });
}

/**
 * Go to page
 * @param {Object} props
 * @param {Number} pageIndex
 */
function goToPage(props: any, pageIndex: Number) {
  const {
    store: { model }
  } = props;
  model.updatePageIndex(pageIndex);

  props.loadHistories();
}

/**
 * On page size change
 * @param {Object} props
 * @param {Number} pageSize
 */
function onPageSizeChange(props: any, pageSize: Number) {
  const {
    store: { model }
  } = props;
  model.updatePageSize(pageSize);

  props.loadHistories();
}

/**
 *On sort change, only support single-sort
 * @param {Object} props
 * @param {string} columnKey
 * @param {*} sortDir
 */
function onSortChange(props: any, columnKey: string, sortDir: any) {
  const {
    store: { model }
  } = props;
  model.setSortInfo(columnKey, sortDir); // Set to show in UI

  props.loadHistories();
}

const actions = withHandlers({
  handleCheckAll: curry(handleCheckAll),
  handleCheckItem: curry(handleCheckItem),
  handleDeleteItem: curry(handleDeleteItem),
  goToPage: curry(goToPage),
  onPageSizeChange: curry(onPageSizeChange),
  onSortChange: curry(onSortChange)
});

export default actions;



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/ImportHistory/ImportHistoryList/Izenda.ImportHistoryListActions.js